package common.constants

import androidx.compose.ui.graphics.Color
import common.asset.ImageAsset
import feature.businessMenu.modal.BusinessMenu
import feature.businessMenu.modal.MenuType

class StoreMenuConfig {
    fun getMenu(): List<BusinessMenu> {
        val firstMenu: ArrayList<BusinessMenu> = arrayListOf()
        firstMenu.add(
            BusinessMenu(
                "my_business_currency",
                MenuType.MENU,
                "Currency",
                ImageAsset.receiptIcon,
                "my_business_currency",
                Color(0xFFE3F5E2)
            )
        )
        firstMenu.add(
            BusinessMenu(
                "my_business_back_account",
                MenuType.MENU,
                "Account",
                ImageAsset.saleIcon,
                "my_business_back_account",
                Color(0xFFF5F5D5)
            )
        )

        val secondMenu: ArrayList<BusinessMenu> = arrayListOf()
        secondMenu.add(
            BusinessMenu(
                "my_business_banner",
                MenuType.MENU,
                "Banner",
                ImageAsset.productMenuIcon,
                "my_business_banner",
                Color(0xFFDEF4F8)
            )
        )
        secondMenu.add(
            BusinessMenu(
                "advertise_to_customer",
                MenuType.MENU,
                "Notify Customer",
                ImageAsset.categoryMenuIcon,
                "advertise_to_customer",
                Color(0xFFE7E7E7)
            )
        )
        val thirdMenu: ArrayList<BusinessMenu> = arrayListOf()

        thirdMenu.add(
            BusinessMenu(
                "my_business_app",
                MenuType.MENU,
                "App",
                ImageAsset.businessIcon,
                "my_business_app",
                Color(0xFFBCDBFF)
            )
        )

        thirdMenu.add(
            BusinessMenu(
                "my_business_app_dashboard",
                MenuType.MENU,
                "Dashboard",
                ImageAsset.dashboardIcon,
                "my_business_app_dashboard",
                Color(0xFFE2F1E9)
            )
        )


        val allMenuItems = listOf(
            BusinessMenu(
                "my_business_finance",
                MenuType.HEADER,
                "Finance",
                ImageAsset.shoppingCart,
                "my_business_finance",
                Color(0xFFF5F5D5)
            ),
            BusinessMenu(
                "my_business_finance",
                MenuType.MENU,
                "",
                ImageAsset.shoppingCart,
                "business_sale",
                Color(0xFFffffff),
                firstMenu
            ),
            BusinessMenu(
                "my_business_marketing",
                MenuType.HEADER,
                "Marketing",
                ImageAsset.shoppingCart,
                "my_business_marketing",
                Color(0xFFDEF4F8)
            ),
            BusinessMenu(
                "my_business_marketing",
                MenuType.MENU,
                "",
                ImageAsset.shoppingCart,
                "my_business_marketing",
                Color(0xFFffffff),
                secondMenu
            ),
            BusinessMenu(
                "my_business_app",
                MenuType.HEADER,
                "Apps",
                ImageAsset.shoppingCart,
                "my_business_app",
                Color(0xFFDEF4F8)
            ),
            BusinessMenu(
                "my_business_app",
                MenuType.MENU,
                "",
                ImageAsset.shoppingCart,
                "my_business_app",
                Color(0xFFffffff),
                thirdMenu
            )
        )
        return allMenuItems
    }
}